import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';

const PreviewButton = styled.div`
  display: flex;
  width: auto;
  align-items: center;
  cursor: pointer;
  background-color: rgba(60, 72, 82, 0.48);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_2B};
  position: absolute;
  bottom: ${Spacings.SPACING_3B};
  left: ${Spacings.SPACING_3B};
  backdrop-filter: blur(4px);
  transition: all 400ms ease;

  &:hover {
    background-color: rgba(60, 72, 82, 1);
  }
`;

export default PreviewButton;

PreviewButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
